import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Dialog, Loading, Typography } from 'wtb-components';
import { useAppContext } from 'context';
import styles from './DialogError.module.css';

const DialogError = () => {
  const { t: translate } = useTranslation();

  const {
    errorDialogCode,
    errorDialogTitle,
    errorDialogMessage,
    closeErrorDialog
  } = useAppContext();

  const getTitle = () => {
    if (errorDialogTitle) return errorDialogTitle;

    if (errorDialogCode === 422) return translate('customerInfo.dialogError.title422');
    else return translate('customerInfo.dialogError.title500');
  };

  const getContent = () => {
    if (errorDialogMessage) return errorDialogMessage;

    if (errorDialogCode === 422) return translate('customerInfo.dialogError.content422');
    else return translate('customerInfo.dialogError.content500');
  };

  return (
    <Dialog
      isOpen={!!errorDialogCode}
      hasCloseIcon={false}
      popupClassName={styles.dialog}
    >
      <Loading
        className={styles.steadyPrimary}
        type="linear"
        variant="determinate"
        value={100}
      />

      <div className={styles.title}>
        <Typography variant="subtitle1" align="center" role="heading" aria-level="1">
          {getTitle()}
        </Typography>
      </div>

      <div className={styles.contentWrapper}>
        <Typography variant="body2" className={styles.content} role="alert">
          {getContent()}
        </Typography>

        <div className={styles.buttonWrapper}>
          <Button
            variant="text"
            className={styles.button}
            onClick={closeErrorDialog}
          >
            {translate('customerInfo.dialogError.action')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogError;
